import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { motion } from "framer-motion";

const Opiniones = () => {
  const opiniones = [
    {
      fecha: "Miércoles 4 de Agosto , 2021",
      opinion:
        "Maravilloso servicio, mi paquete llegó muy rápido y en excelentes condiciones.",
      nombre: "Julio Corona Castillo",
      cargo: "Gerente general, Puebla, Pue",
    },
    {
      fecha: "Lunes 11 de Octubre , 2021",
      opinion:
        "El servicio de paquetería ligera es muy eficiente y además el personal es muy atento.",
      nombre: "Ana Bonilla",
      cargo: "Recursos Humanos, Ciudad de México",
    },
    {
      fecha: "Lunes 27 de Diciembre , 2021",
      opinion:
        "El generador de luz fue nuestro mejor acompañante en el viaje que realizamos a supervisar una de nuestras obras.",
      nombre: "Roberto Zamorano",
      cargo: "Gerente de Operaciones, Puebla",
    },
    {
      fecha: "Miércoles 30 de Marzo , 2022",
      opinion:
        "Cargar gasolina desde nuestras instalaciones nos ha permitido tener mayor control en los gastos destinados a combustible.",
      nombre: "Paola Espidio",
      cargo: "Logística, Puebla",
    },
    {
      fecha: "Lunes 21 de Marzo , 2022",
      opinion:
        "No creí que el servicio de envío de documentos fuera tan veloz. Requería enviar unos papeles importantes y el servicio superó mis expectativas.",
      nombre: "Pedro Carrión",
      cargo: "Finanzas, Puebla",
    },
    {
      fecha: "Lunes 2 de Agosto , 2021",
      opinion:
        "Mis documentos se entregaron en tiempo y forma, excelente servicio.",
      nombre: "Aldo Romero Olvera",
      cargo: "Gerente general, Puebla, Pue",
    },
  ];

  return (
    <div className="w-full h-screen flex flex-col items-center justify-center px-4 md:px-24">
      <motion.h2
        className="text-4xl text-sky-700 font-bold mb-6"
        initial={{ y: -40, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        Testimonios
      </motion.h2>

      <div className="h-1 w-32 bg-sky-400 mb-8" />

      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{ clickable: true }}
        autoplay={{ delay: 5000 }}
        loop={true}
        className="w-full md:w-3/4"
      >
        {opiniones.map((op, idx) => (
          <SwiperSlide key={idx}>
            <motion.div
              className="flex flex-col items-center gap-6 text-center px-6"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <p className="font-light text-gray-500">{op.fecha}</p>
              <h2 className="text-xl md:text-2xl text-sky-700 font-semibold leading-relaxed">
                “{op.opinion}”
              </h2>

              <div className="bg-sky-800 px-6 py-4 rounded-full text-white text-center">
                <p className="text-lg font-medium">{op.nombre}</p>
                <p className="text-sm">{op.cargo}</p>
              </div>
            </motion.div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Opiniones;
